// extracted by mini-css-extract-plugin
export default {"pageLayout":"Fa-z","mainContent":"Ga-z","columnLayout":"Ha-z","columnLayoutFill":"Ia-z","columnLayoutLast":"Ja-z"};